<!--  -->
<template>
  <div>
    <div>
      <el-date-picker
        v-model="date"
        style="margin: 0px 15px 0px 0px;"
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions"
      />
      <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      <!-- <el-button type="info" icon="el-icon-refresh-right" @click="reast">重置</el-button> -->
    </div>

    <el-table
      :data="tableData"
      style="width: 100%;margin-top:10px"
      max-height="500"
      border
    >
      <el-table-column
        prop="msg_id"
        label="图文消息id"
        width="130"
        align="center"
      />
      <el-table-column
        prop="index"
        label="消息次序索引"
        width="100"
        align="center"
      />
      <!-- <el-table-column
        prop="title"
        label="标题"
        width="100"
        align="center"
      /> -->
      <el-table-column
        prop="title"
        label="标题"
        align="center"
        width="100"
      >
        <template slot-scope="scope">
          <el-popover
            placement="top-start"
            title="标题"
            width="300"
            trigger="hover"
            :content="scope.row.title"
          >
            <p slot="reference" class="titip">{{ scope.row.title }}</p>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column
        prop="ref_date"
        label="日期"
        align="center"
        width="100"
      />
      <el-table-column
        prop="int_page_read_user"
        label="图文页的阅读人数"
        align="center"
        width="100"
      />
      <el-table-column
        prop="int_page_read_count"
        label="图文页的阅读次数"
        align="center"
        width="100"
      />
      <el-table-column
        prop="ori_page_read_user"
        label="原文页的阅读人数"
        align="center"
        width="100"
      />
      <el-table-column
        prop="ori_page_read_count"
        label="原文页的阅读次数"
        align="center"
        width="100"
      />
      <el-table-column
        prop="share_user"
        label="分享的人数"
        align="center"
        width="100"
      />
      <el-table-column
        prop="share_count"
        label="分享的次数"
        align="center"
        width="100"
      />
      <el-table-column
        prop="add_to_fav_user"
        label="收藏的人数"
        align="center"
        width="100"
      />
      <el-table-column
        prop="add_to_fav_count"
        label="收藏的次数"
        align="center"
        width="100"
      />
      <el-table-column
        prop="created_at_text"
        label="创建时间"
        align="center"
      />
    </el-table>
    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { readStslist } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { PaginationRight },
  data() {
    return {
      query: {
        page_size: 10,
        page: 1,
        msg_id: null,
        app_id: null
      },
      total: null,
      date: [],
      tableData: [],
      pickerOptions: { // 禁用当前日期之前的日期
        disabledDate(time) {
          // Date.now()是javascript中的内置函数，它返回自1970年1月1日00:00:00 UTC以来经过的毫秒数。
          return time.getTime() > Date.now() - 8.64e7
        }
      }
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    send(msg_data_id) {
      this.datafliter()
      console.log('msg_data_id', msg_data_id)
      this.query.msg_id = msg_data_id
      this.list()
    },
    async list() {
      const data = await readStslist({
        page: this.query.page,
        page_size: this.query.page_size,
        msg_id: this.query.msg_id,
        from_date: this.date[0],
        to_date: this.date[1],
        app_id: this.query.app_id
      })
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    datafliter() {
      // 默认当前日期8天前，最后日期昨天
      const today = new Date()
      const firstDate = new Date(today)
      firstDate.setDate(today.getDate() - 10)
      const secondDate = new Date(today)
      secondDate.setDate(today.getDate() - 1)
      // secondDate.setDate(today.getDate())
      const firstDateString = this.formatDate(firstDate)
      const secondDateString = this.formatDate(secondDate)
      this.date = [firstDateString, secondDateString]
    },
    // 时间转化
    formatDate(date) {
      const year = date.getFullYear()
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const day = date.getDate().toString().padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    search() {
      this.query.page = 1
      this.list()
    },
    // 分页
    fetchPageSize(e) {
      this.query.page_size = e
      this.list()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.list()
    }
    // reast() {
    //   this.query.page = 1
    //   this.query.page_size = 10
    //   this.query.page_size = 10
    // }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.titip{
    width: 80px;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1; /* 这里是超出几行省略 */
    overflow: hidden;
}
</style>
